
import InputElement from './InputElement'
import TextareaElement from './TextareaElement'

const InputStep = (props) => {
	const state = props.state;
	const handleChange = props.handleChange;
	const handleClick = props.handleClick;
    return (
        <div className="input-step">
            <p className="error-step">{state.error}</p>
            <InputElement label="Nom" name="nom" value={state.nom} handleChange={handleChange} required={true} />
            <InputElement label="Prénom" name="prenom" value={state.prenom} handleChange={handleChange} required={true} />
            <InputElement label="Email" name="email" value={state.email} handleChange={handleChange} required={true} />
            <InputElement label="Téléphone" name="telephone" value={state.telephone} handleChange={handleChange} />
            <TextareaElement label="Message" name="message" value={state.message} handleChange={handleChange} required={true} />
            <p className="right">
                <label></label>
                <button type="button" onClick={handleClick}>Envoyer</button>
            </p>
        </div>
    )
}

export default InputStep